// extracted by mini-css-extract-plugin
export default {"root":"wO3Pbaa7FH","textHelper":"zL16p8KdWg"};